import React from 'react';
import { useLanguage } from './LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#050505] py-12 border-t border-white/5 text-center" data-id="element-31">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center" data-id="element-32">
        <h4 className="text-2xl font-playfair text-white mb-2" data-id="element-33">
          Bella Beauty Couture
        </h4>
        <p className="text-studio-gold font-playfair italic mb-8" data-id="element-34">
          {t('footer.by')}
        </p>

        <a href="https://www.instagram.com/nikkis_hairdressing_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="mb-8 inline-block hover:scale-110 transition-transform duration-300" aria-label="Follow us on Instagram" data-id="element-35">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-36">
            <defs data-id="element-37">
              <radialGradient id="ig-gradient-footer" cx="30%" cy="107%" r="150%" data-id="element-38">
                <stop offset="0%" stopColor="#fdf497" data-id="element-39" />
                <stop offset="5%" stopColor="#fdf497" data-id="element-40" />
                <stop offset="45%" stopColor="#fd5949" data-id="element-41" />
                <stop offset="60%" stopColor="#d6249f" data-id="element-42" />
                <stop offset="90%" stopColor="#285AEB" data-id="element-43" />
              </radialGradient>
            </defs>
            <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#ig-gradient-footer)" strokeWidth="2" fill="none" data-id="element-44" />
            <circle cx="12" cy="12" r="4.5" stroke="url(#ig-gradient-footer)" strokeWidth="2" fill="none" data-id="element-45" />
            <circle cx="17.5" cy="6.5" r="1.25" fill="url(#ig-gradient-footer)" data-id="element-46" />
          </svg>
        </a>

        <div className="text-xs text-gray-600 font-inter tracking-widest uppercase" data-id="element-47">
          <p className="mb-2" data-id="element-48">{t('footer.address')}</p>
          <p data-id="element-49">
            &copy; {new Date().getFullYear()} Bella Beauty Couture.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}